import React, { useEffect, useState } from "react";
import { Col, Container, Row, Form, Button, Spinner, Table, Nav, Tab, } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useSelector } from "react-redux";
import Pagination from "../Common/Pagination";

const GatPropertyVisitReport = () => {
    const [key, setKey] = useState("dilievered");
    const userState = useSelector(state => state?.loginData?.userData);
    const selectedFinancialYear = useSelector((state) => state.activeData.financialYear);

    const navigate = useNavigate();

    // Variables for Zone-Gat Visitors Data ------------
    const [contractor, setContractor] = useState('');
    const [loader, setLoader] = useState(false);

    // States for Pagination ----------
    const [pageNo, setPageNo] = useState(1);
    const [docPerPage, setDocPerPage] = useState(50);
    const [noOfPages, setNoOfPages] = useState(0);

    // Search variables----
    const [searchMobile, setSearchMobile] = useState("");
    const [searchMobErr, setSearchMobErr] = useState(false);
    const [searchProperty, setSearchProperty] = useState("");
    const [searchPropErr, setSearchPropErr] = useState(false);

    //
    const [propertyFound, setPropertyFound] = useState(false)

    // function for pagination

    const handlePageChange = (pageNumber) => {
        setPageNo(pageNumber);
    };

    const handleDocsPerPage = (docsPageProp) => {
        setPageNo(1);
        setDocPerPage(docsPageProp);
    };

    //   useEffect API Calls
    useEffect(() => {
        getVisitReportList();
    }, [docPerPage, pageNo, propertyFound,selectedFinancialYear]);

    // get List API
    const getVisitReportList = async () => {
        setLoader(true);
        await fetch(
            process.env.REACT_APP_BASE_URL +
            "/billDistribution/getAllBillDistributionsPGN"
            ,
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    isPropertyFound: propertyFound,
                    propertyCode: searchProperty,
                    visitingPersonContactNo: searchMobile,
                    documentsPerPage: docPerPage,
                    page: pageNo,
                    financialYear: "2025-2026",
                    gatkey: userState?.gatkey,
                    financialYear: selectedFinancialYear,
                }),
            }
        )
            .then((res) => res.json())
            .then((response) => {
                if (response.status === 200) {
                    setContractor(response);
                    setNoOfPages(response.noOfPages);
                    setLoader(false)
                } else {
                    setContractor('')
                    setLoader(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setLoader(false);
            });
    };

    const searchByProperty = async () => {
        if (searchProperty.length > 0) {
            getVisitReportList();
        } else {
            setSearchPropErr(true);
        }
    };

    return (
        <div className="visitReport">
            <ToastContainer />
            <Container>
                <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                    <Row className="justify-content-center">
                        <Col
                            md={4}
                            className="searchCard m-2"
                            style={{ paddingLeft: 10, paddingRight: 10, paddingBottom: 10 }}
                        >
                            <div className="label mb-2 mx-auto">
                                <p>Search by Property Code</p>
                            </div>
                            <div className="d-flex mt-1">
                                <Form.Control
                                    placeholder="Property Code"
                                    pattern="[0-9]*"
                                    value={searchProperty}
                                    onChange={(e) => {
                                        if (!/^[0-9]*\.?[0-9]*$/.test(e.target.value)) {
                                            e.target.setCustomValidity("Please enter only numbers.");
                                        } else {
                                            e.target.setCustomValidity("");
                                            setSearchProperty(e.target.value);
                                        }
                                    }}
                                />

                                <Button
                                    className="btn-submit ms-3"
                                    onClick={() => searchByProperty()}
                                >
                                    <Icon.Search className="me-2" size={14} />
                                    Search
                                </Button>
                            </div>
                            {searchPropErr ? (
                                <p className="errMsg">Please enter valid property code</p>
                            ) : null}
                        </Col>
                        <Col md={6} className="p-0  mt-3 mb-3 mx-auto">
                            <Nav variant="pills" className="flex-row">
                                <Nav.Item>
                                    <Nav.Link onClick={() => setPropertyFound(false)} eventKey="dilievered">Delivered</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link onClick={() => setPropertyFound(true)} eventKey="notdilievered">Not Delivered</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Col>
                    </Row>
                    <Row className="visitors mt-2">
                        <Tab.Content>
                            <Tab.Pane eventKey="dilievered">
                                <div className="container tbl-container p-0">
                                    <div className="row tbl-fixed p-0" style={{ maxHeight: "65vh" }}>
                                        <Table responsive="lg" hover>
                                            <thead>
                                                <th>Sr No.</th>
                                                <th>Property Code</th>
                                                <th>Property Owner Name</th>
                                                <th>Property Owner Contact No</th>
                                                <th>Property Address</th>
                                                <th>Zone Name</th>
                                                <th>Gat Name</th>
                                                <th>Visit Person Name</th>
                                                <th>Visit Date</th>
                                                <th>Action</th>
                                            </thead>
                                            <tbody>
                                                {loader ? (
                                                    <center>
                                                        <Spinner />
                                                    </center>
                                                ) : contractor?.data && contractor.data.length > 0 ? (
                                                    contractor.data.map((row, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    {pageNo !== 1 ? (
                                                                        <> {index + 1 + docPerPage * (pageNo - 1)}</>
                                                                    ) : (
                                                                        <>{index + 1}</>
                                                                    )}
                                                                </td>
                                                                <td>{row?.propertyCode ? row?.propertyCode : "-"}</td>
                                                                <td>{row?.propertyName ? row?.propertyName : "-"}</td>
                                                                <td>
                                                                    {row?.propertyContactNo
                                                                        ? row?.propertyContactNo
                                                                        : "-"}
                                                                </td>
                                                                <td>
                                                                    {row?.propertyAddress ? row?.propertyAddress : "-"}
                                                                </td>
                                                                <td>{row?.zonename ? row?.zonename : "-"}</td>
                                                                <td>{row?.gatname ? row?.gatname : "-"}</td>
                                                                <td>
                                                                    {row?.visitingPersonName
                                                                        ? row?.visitingPersonName
                                                                        : "-"}
                                                                </td>
                                                                <td>
                                                                    {row?.visitDate
                                                                        ? moment(row?.visitDate).format("DD MMM YYYY")
                                                                        : "-"}
                                                                </td>
                                                                <td className="text-center">
                                                                    <Icon.Eye
                                                                        style={{ cursor: "pointer" }}
                                                                        size={25}
                                                                        onClick={() => {
                                                                            navigate("/dashboard/gat-view-property-report",
                                                                                {
                                                                                    state: {
                                                                                        report: row,
                                                                                        comesFrom: "Visit Report",
                                                                                    },
                                                                                }
                                                                            )
                                                                        }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>No data found</tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <Row>
                                        <Col md={4} className="d-flex align-items-center mt-3 mt-md-0">
                                            <h6 className="text-start mb-0">
                                                <Icon.People className="me-2" />
                                                Total -{" "}
                                                <strong>{contractor?.count ? contractor?.count : 0}</strong>
                                            </h6>
                                        </Col>
                                        <Col md={8} className="d-flex justify-content-end">
                                            <Pagination
                                                currentPage={pageNo}
                                                totalPages={noOfPages}
                                                onPageChange={handlePageChange}
                                                onDocsPerPage={handleDocsPerPage}
                                                docsPerPage={docPerPage}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="notdilievered">
                                <div className="container tbl-container p-0">
                                    <div className="row tbl-fixed p-0" style={{ maxHeight: "65vh" }}>
                                        <Table responsive="lg" hover>
                                            <thead>
                                                <th>Sr No.</th>
                                                <th>Property Code</th>
                                                <th>Property Owner Name</th>
                                                <th>Property Owner Contact No</th>
                                                <th>Property Address</th>
                                                <th>Zone Name</th>
                                                <th>Gat Name</th>
                                                <th>Visit Person Name</th>
                                                <th>Visit Date</th>
                                                <th>Action</th>
                                            </thead>
                                            <tbody>
                                                {loader ? (
                                                    <center>
                                                        <Spinner />
                                                    </center>
                                                ) : contractor?.data && contractor.data.length > 0 ? (
                                                    contractor.data.map((row, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    {pageNo !== 1 ? (
                                                                        <> {index + 1 + docPerPage * (pageNo - 1)}</>
                                                                    ) : (
                                                                        <>{index + 1}</>
                                                                    )}
                                                                </td>
                                                                <td>{row?.propertyCode ? row?.propertyCode : "-"}</td>
                                                                <td>{row?.propertyName ? row?.propertyName : "-"}</td>
                                                                <td>
                                                                    {row?.propertyContactNo
                                                                        ? row?.propertyContactNo
                                                                        : "-"}
                                                                </td>
                                                                <td>
                                                                    {row?.propertyAddress ? row?.propertyAddress : "-"}
                                                                </td>
                                                                <td>{row?.zonename ? row?.zonename : "-"}</td>
                                                                <td>{row?.gatname ? row?.gatname : "-"}</td>
                                                                <td>
                                                                    {row?.visitingPersonName
                                                                        ? row?.visitingPersonName
                                                                        : "-"}
                                                                </td>
                                                                <td>
                                                                    {row?.visitDate
                                                                        ? moment(row?.visitDate).format("DD MMM YYYY")
                                                                        : "-"}
                                                                </td>
                                                                <td className="text-center">
                                                                    <Icon.Eye
                                                                        style={{ cursor: "pointer" }}
                                                                        size={25}
                                                                        onClick={() => {
                                                                            navigate("/dashboard/gat-view-property-report",
                                                                                {
                                                                                    state: {
                                                                                        report: row,
                                                                                        comesFrom: "Visit Report",
                                                                                    },
                                                                                }
                                                                            )
                                                                        }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>No data found</tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <Row>
                                        <Col md={4} className="d-flex align-items-center mt-3 mt-md-0">
                                            <h6 className="text-start mb-0">
                                                <Icon.People className="me-2" />
                                                Total -{" "}
                                                <strong>{contractor?.count ? contractor?.count : 0}</strong>
                                            </h6>
                                        </Col>
                                        <Col md={8} className="d-flex justify-content-end">
                                            <Pagination
                                                currentPage={pageNo}
                                                totalPages={noOfPages}
                                                onPageChange={handlePageChange}
                                                onDocsPerPage={handleDocsPerPage}
                                                docsPerPage={docPerPage}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </Tab.Pane>
                        </Tab.Content>
                    </Row>
                </Tab.Container>
            </Container>
        </div>
    );
};

export default GatPropertyVisitReport;
